import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import {
  OpportunityConfigBuilderRequest,
  OpportunityConfigBuilderResponse,
} from "lib/generated/integration-api";
import { useIntegrationApi } from "lib/integrationApiContext";

type RequestParams = {
  request: OpportunityConfigBuilderRequest;
};

export function useUpdateOpportunityConfig(
  options?: UseMutationOptions<OpportunityConfigBuilderResponse, unknown, RequestParams, unknown>,
) {
  const api = useIntegrationApi();
  return useMutation(
    ({ request }: RequestParams) =>
      api.updateOpportunityConfig({
        opportunityConfigBuilderRequest: request,
      }),
    options,
  );
}
